import { createTheme } from "@material-ui/core"

const theme = createTheme({
  navHeight: 62,
  sectionPadding: "padding-top: 1.5em; padding-bottom: 1.5em;",
  fonts: {
    primary: "Barlow, sans-serif",
    secondary: "Castoro, sans-serif",
  },
  layout: {
    contentWidth: 1236,
  },
  palette: {
    primary: {
      // contrastText: "rgba(0, 0, 0, 0.87)",
      main: "#DC032F",
      light: "#B50529",
      dark: "#A10121",
    },
    secondary: {
      main: "#979797",
      light: "#F4F4F4",
      dark: "#1F1D2F",
    },
    tertiary: {
      main: "#2C9ED0",
    },
    text: {
      primary: "#000000",
      secondary: "#FFFFFF",
      content: "#848484",
      tertiary: "#1A2933",
      disabled: "#10355A",
      hint: "#10355A",
      light: "#EEEEEE",
    },
    alternate: {
      main: "rgb(247, 249, 250)",
      dark: "#e8eaf6",
    },
  },
  typography: {
    fontFamily: `"Barlow", "Open Sans", "Arial", sans-serif`,
  },
})
export default theme
